
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/port-drayage",
      function () {
        return require("private-next-pages/port-drayage.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/port-drayage"])
      });
    }
  